var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"siteFooter"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" David Jewell • v"+_vm._s(_vm.vers))])])
}
var staticRenderFns = []

export { render, staticRenderFns }